module.exports = __webpack_public_path__ + "img/trinity-finance.19ad9ef5.png";